<template>
  <div>
    <div class="page-container lsp-add-container demand-details">
      <b-container>
        <b-row>
            <div class="ft-form-title">
              <div @click="handleOnClickBack">
                <icon-base icon-name="translate" width="24" height="24" viewBox="0 0 24 24">
                  <icon-left-arrow/>
                </icon-base>
                <span>
                  {{title}}
                </span>
              </div>
            </div>
        </b-row>
        <div class="mt-3">
          <b-row>
            <b-col>
              <label class="d-block">{{ "Select route" }}</label>
              <b-row>
                <b-col cols="12">
                  <b-input-group class="mb-2 ft-input-group step-1">
                    <!-- <b-input-group-prepend is-text >
                                          <b-icon icon="square-fill" variant="info" font-scale="0.5"></b-icon>
                                      </b-input-group-prepend> -->
                    <div class="w-100" @click="onAddRoute">
                    <b-form-input
                      type="text"
                      v-model="origin"
                      :placeholder="$t('message.loadig_city')"
                      :state="$v.origin.$dirty ? !$v.origin.$error : null"
                      @input="$v.origin.$touch()"
                      autocomplete="off"
                      disabled
                    >
                    </b-form-input>
                    </div>
                    <b-form-invalid-feedback>
                      {{ "This field cannot be left blank" }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-2 ft-input-group step-2">
                    <!-- <b-input-group-prepend is-text>
                                          <b-icon icon="square-fill" variant="secondary" font-scale="0.5"></b-icon>
                                      </b-input-group-prepend> -->
                    <div class="w-100" @click="onAddRoute">
                    <b-form-input
                      type="text"
                      v-model="destination"
                      :placeholder="$t('message.unLoading_city')"
                      :state="$v.destination.$dirty ? !$v.destination.$error : null"
                      @input="$v.destination.$touch()"
                      autocomplete="off"
                      disabled
                    >
                    </b-form-input>
                    </div>
                    <b-form-invalid-feedback>
                      {{ "This field cannot be left blank" }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group>
                <label class="d-block">{{ "Select vehicle type" }}</label>
                <div class="w-100" @click="showSelectVehicleModal">
                <b-form-input
                  type="text"
                  v-model="vehicle_type"
                  :placeholder="$t('message.selectVehiclePlaceholderText')"
                  :state="$v.vehicle_type.$dirty ? !$v.vehicle_type.$error : null"
                  autocomplete="off"
                  disabled
                ></b-form-input>
                </div>
                <b-form-invalid-feedback>
                  {{ "This field cannot be left blank" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="">
            <b-col cols="5" style="padding-right: 1px">
              <b-form-group>
                <label for="vehicle-qty" class="d-block">{{
                  "No. of vehicles"
                }}</label>

                <b-form-spinbutton
                  id="vehicle-qty"
                  v-model="vehicle_qty"
                  min="1"
                  class="mb-2 btn-spinner"
                ></b-form-spinbutton>
              </b-form-group>
            </b-col>
            <b-col cols="2" style="text-align: center; margin-top: 35px">
              <span class="">
                <icon-base icon-name="close" width="20" height="14"
                  ><icon-close
                /></icon-base>
              </span>
            </b-col>
            <b-col cols="5" style="padding-left: 1px">
              <b-form-group class="mb-0">
                <label for="vehicle-rate" class="d-block">{{
                  $t("message.vehicleRateLabel")
                }}</label>
                <b-form-input
                  id="vehicle-rate"
                  v-model="biddingprice"
                  @blur="vehicleRateOnBlur"
                  @focus="isInputActive = true"
                  placeholder=""
                  ref="biddingprice"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group description="No more than 500 characters">
                <label for="comment" class="d-block">{{ "Comments" }}</label>
                <b-form-textarea id="comment" v-model="comment" maxlength="500"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-container>

      <RouteModal
        @add-route="add_Route"
        :routes_list="routes_list"
        type="single"
      />
      <vehicle-types
        type="single"
        @update-vehicle-types="updateVehicleTypes"
        :vehicleTypes="vehicleType"
      />
    </div>
    <!-- <b-col cols="12"> -->
    <div class="ft-btn-block fixed">
      <b-button
        class="ft-btn ft-btn-primary"
        :disabled="(showPlaceBidLoader || $v.$invalid)"
        block
        @click="submitDemand"
      >
        <b-spinner
          v-if="showPlaceBidLoader"
          small
          label="Small Spinner"
        ></b-spinner>
        {{ "Submit" }}
      </b-button>
    </div>
    <!-- </b-col> -->
  </div>
</template>

<script>
// import RouteSelection from '../components/RouteSelection.vue'
import RouteModal from "../components/modals/LoadRouteModal.vue";

import VehicleTypes from "../components/modals/VehicleTypes.vue";
import IconBase from "../components/IconBase.vue";
import IconClose from "../components/icons/IconClose.vue";
import IconLeftArrow from "../components/icons/IconLeftArrow.vue";
import axios from "axios";

import { required } from "vuelidate/lib/validators";

import { formatPrice } from "../util/commonUtil";

import { MX_TRACK_LSP } from "../utils/Mixpanel.js";
const Hotjar = require("../utils/Hotjar.js");
import config from "../config/config.js";

const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL;

export default {
  components: {
    RouteModal,
    VehicleTypes,
    IconBase,
    IconClose,
    IconLeftArrow
  },
  data() {
    return {
      origin: "",
      destination: "",
      vehicle_type: "",
      comment: "",
      routeType: "",
      routes_list: [],
      routes_dup: {},
      vehicleType: {},
      vehicle_qty: 1,
      isInputActive: false,
      rate_received: "",
      showPlaceBidLoader: false,
      tile: "Add Load"
    };
  },
  validations: {
    vehicle_type: { required },
    origin: { required },
    destination: { required },
  },
  watch: {
    '$store.state.lspLoadDetail': {
      immediate: true,
      handler() {
        const load = this.$store.getters.getLspLoadDetail
        this.routes_list = {
          "origin": load.origin,
          "origin_place_id": load.origin_place_id,
          "origin_terms": load.origin_terms,
          "destination": load.destination,
          "destination_place_id": load.destination_place_id,
          "destination_terms": load.destination_terms
        },
        this.origin = load.origin
        this.destination = load.destination
        this.vehicle_type = load.truck_type
        this.vehicleType = {
          id: load.truck_type_id,
          label: load.truck_type
        }
        this.vehicle_qty = load.required_no_of_trucks || 1
        this.rate_received = 0
        this.comment = load.comment
        if (load._type) {
          this.$nextTick(() => {
            this.$refs.biddingprice.focus();
          })
        }
        if (load._type && load._type == "supply") {
          this.title = "Quick Add"
        } else {
          this.title = "Add Load"
        }
      }
    }
  },
  methods: {
    vehicleRateOnBlur() {
      this.isInputActive = false;
      this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LSP_RATE_ENTERED);
    },
    async onAddRoute() {
      this.$root.$emit("on-add-route", null);
    },
    add_Route(route) {
      this.routes_list = route;
      this.routes_dup = route;
      this.origin = route.origin;
      this.destination = route.destination;

      if (route.origin != "") {
        this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LSP_ORIGIN_SELECTD);
      }

      if (route.destination != "") {
        this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LSP_ORIGIN_SELECTD);
      }
    },
    showSelectVehicleModal() {
      this.$bvModal.show("ft-vehicle-types-modal");

      this.trackMixpanelEvent(
        config.MIXPANEL_EVENTS.LSP_ATTEMP_TO_SELECT_VEHICLE
      );
    },
    updateVehicleTypes(data) {
      this.vehicleType = data;
      this.vehicle_type = data.label;
      this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LSP_VEHICLE_SELECTED);
    },
    async submitDemand() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.showPlaceBidLoader = true;

        const reqData = {
          rate: this.rate_received,
          required_no_of_trucks: this.vehicle_qty,
          truck_type_id: this.vehicleType.id,
          truck_type: this.vehicleType.label,
          comment: this.comment,
          status: "OPEN",
          ...this.routes_list,
        };

        try {
          const { data } = await axios.post(
            `${API_BASE_URL}/demand/${this.$route.params.id}`,
            reqData
          );
          if (data && data.success && data.value) {
            this.toast(
              "success",
              "b-toaster-bottom-center",
              "1 load added successfully",
              true
            );
            this.$store.commit("updateLspDemandList", [
              ...this.$store.getters.getLspDemandList,
              data.value,
            ]);
            this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LSP_LOAD_SUBMITTED);
            this.$router.push(
              `/${this.$route.params.lang}/lsp_app/list/${this.$route.params.id}?tab=loads`
            );
          }
        } catch (error) {
          let errorData;
          if (error.response) {
            const { data, status, header } = error.response;
            errorData = {
              response: data,
              status,
              header,
              errorType: "API_ERROR",
            };
          } else if (error.request) {
            errorData = {
              errorType: "NO_RESPONSE_RECEIVED",
            };
          } else {
            errorData = {
              message: error.message,
              errorType: "JS_ERROR",
            };
          }
          console.log(errorData);
          this.toast(
            "danger",
            "b-toaster-bottom-center",
            "Failed to add load",
            true
          );
          this.showPlaceBidLoader = false;
          this.trackMixpanelEvent("Failed_to_add_load", { errorData });
        }
        this.showPlaceBidLoader = false;
      }
    },
    toast(variant, toaster, text, append = false) {
      this.$bvToast.toast(text, {
        toaster: toaster,
        solid: true,
        variant: variant,
        appendToast: append,
        noCloseButton: true,
      });
    },
    trackMixpanelEvent(event, data = {}) {
      const demandDetails = this.$store.getters.getDemandDetails.value;
      if (demandDetails) {
        const lspList = this.$store.getters.getLspDemandList;
        const mx_prop = {
          user_name: demandDetails.name,
          phone_number: demandDetails.phone,
          user_id: demandDetails.demand_id,
          loads_added_today: lspList.length,
          origin: this.origin,
          destination: this.destination,
          no_of_vehicle: this.vehicle_qty,
          rate: this.rate_received,
        };
        MX_TRACK_LSP(event, { ...mx_prop, ...data });
        Hotjar.IDENTIFY_LSP_APP(self, demandDetails.name, {
          ...mx_prop,
          ...data,
        });
      }
    },
    cacheId() {
      localStorage.setItem("lsp_id", this.$route.params.id);
    },
    handleOnClickBack: function() {
        this.$router.push({ name: 'lsp_list', params: { lang: this.$route.params.lang, id: this.$route.params.id  } })
    }
  },
  computed: {
    biddingprice: {
      get: function () {
        if (this.isInputActive) {
          return this.rate_received.toString();
        } else {
          return formatPrice(this.rate_received);
        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue);
        if (isNaN(newValue)) {
          newValue = 0;
        }
        this.rate_received = newValue;
      },
    },
    submitBtnStatus() {
      let status = true
      if (this.vehicleType.id == undefined) {
        status = false
      }
      // return this.vehicle_qty > 0 && this.routes_list.origin_place_id != undefined && this.routes_list.destination_place_id != undefined && this.vehicleType != undefined
      return status
    }
  },
  mounted() {
    this.cacheId();
  },
};
</script>

<style lang="scss">
.page-container {
  margin-top: 60px;
}
.ft-form-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.15px;
  color: #474747;
  width: 100%;
  padding: 0.5rem;
  margin-top: 0px;
  box-shadow: 0px 0.25px 0.5px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.16);
}
.lsp-add-container {
  background-color: #fff;
  min-height: 100vh;
  .demand-controls {
    padding-top: 0;
    border: none;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #FFFFFF;
  }
}
</style>
